/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import CreateView from '../../view/pages/accommodation_invoice/CreateView'
import AccommodationInvoiceAction from '../../action/accommodation_invoice'
import ReservationStore from '../../store/accommodation_invoice/ReservationStore'
import CreateViewStore from '../../store/accommodation_invoice/CreateViewStore'
import AccommodationTaxStore from '../../store/accommodation_invoice/AccommodationTaxStore'

class CreateContainer extends Component {
  static getStores() {
    return [CreateViewStore, ReservationStore, AccommodationTaxStore]
  }

  static calculateState(prevState, props) {
    return {
      view: CreateViewStore.getState(),
      reservation: ReservationStore.getState(),
      accommodation_tax: AccommodationTaxStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    const id = this.state.match.params.id
    if (id) {
      AccommodationInvoiceAction.fetchReservation(id)
    }
  }

  render() {
    return CreateView(this.state)
  }
}

export default withRouter(Container.create(CreateContainer, { withProps: true }))
